<!--
 * @Author: vince
 * @Date: 2021-08-31 09:43:51
 * @LastEditors: vince 273187189@qq.com
 * @LastEditTime: 2023-06-20 14:49:16
 * @Description:
-->
<template>
  <div class="college" style="height: auto">
    <div class="page" style="display: block">
      <div>
        <span class="page-name mr-md">育德润心</span>
        <!-- <el-button type="primary" size="small" @click="">创建</el-button> -->
      </div>
      <div class="resource-box pa-sm my-md">
        <el-button
          slot="reference"
          type="primary"
          class="mr-sm"
          v-for="item in catalogList"
          @click="onCatalogClick(item, item)"
          :plain="currentCatalogCode != item.catalogCode"
          size="small"
          :key="item.id"
          >{{ item.catalogName }}</el-button
        >
        <el-button
          style="float: right"
          size="small"
          type="primary"
          icon="el-icon-plus"
          @click="onNewResources"
          >上传资源</el-button
        >
      </div>
      <div class="resource-box pa-md">
        <el-form class="full-width mb-2px" :model="filterForm">
          <div class="filter-bar" style="padding: 0px 0px 8px" type="flex">
            <el-form-item class="mb-none" label="名称">
              <el-input
                style="width: 150px"
                size="small"
                v-model="filterForm.keyword"
                clearable
                placeholder="资源名称或教师名"
                @keydown.enter="search"
                @change="search"
              >
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
              </el-input>
            </el-form-item>
            <el-form-item class="mb-none" label="学科">
              <disciplineSelector
                style="width: 150px"
                v-model="filterForm.disciplineTemp"
              ></disciplineSelector>
            </el-form-item>
            <el-form-item class="mb-none" label="年级">
              <grade-selector
                style="width: 150px"
                v-model="filterForm.gradeTemp"
              ></grade-selector>
            </el-form-item>
            <el-form-item class="mb-none" label="资源类型">
              <fileTypeSelector
                style="width: 150px"
                v-model="filterForm.classify"
              ></fileTypeSelector>
            </el-form-item>
            <el-form-item class="mb-none" label="学年" prop="schoolYear">
              <school-year-selector
                style="width: 150px"
                v-model="filterForm.schoolYear"
              ></school-year-selector>
            </el-form-item>
            <el-form-item class="mb-none" label="学期" prop="schoolTerm">
              <school-term-selector
                style="width: 150px"
                v-model="filterForm.schoolTerm"
                :checkAll="false"
              ></school-term-selector>
            </el-form-item>
            <el-form-item class="mb-none">
              <el-checkbox v-model="filterForm.isMine">我上传的</el-checkbox>
            </el-form-item>
          </div>
        </el-form>
        <el-table :data="tableData" v-loading="loading" border>
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column
            prop="catalogName"
            width="150"
            label="资源分类"
            align="left"
          ></el-table-column>
          <el-table-column
            prop="infoName"
            width="150"
            label="资源名称"
            align="left"
          ></el-table-column>
          <!-- <el-table-column prop="catalogCode" width="240" label="资源分类" align="left">
            <template slot-scope="scope">
            <el-cascader size="small" disabled v-model="scope.row.catalogCode" :options="catalogList" :props="{
              value: 'catalogCode',
              label: 'catalogName',
              children: 'catalogList',
              emitPath: false
            }"></el-cascader>
            </template>
          </el-table-column> -->
          <!-- <el-table-column prop="fileList" width="300" label="资源详情" align="center">
            <template slot-scope="scope">
              <fileAgent readonly :deletable="false" :editable="false" v-model="scope.row.fileList"></fileAgent>
            </template>
          </el-table-column> -->
          <el-table-column
            prop="classify"
            label="资源类型"
            align="center"
            :formatter="formatType"
          ></el-table-column>
          <el-table-column
            prop="attachSize"
            :formatter="formatterSize"
            label="资源大小"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="gradeName"
            label="年级"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="disciplineName"
            label="学科"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="createName"
            label="创建人"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="createTime"
            label="上传时间"
            align="center"
          ></el-table-column>
          <!-- <el-table-column
            v-if="filterForm.isMine"
            prop="checkStatus"
            label="审核状态"
            align="center"
          >
            <template slot-scope="scope">
              <el-button
                size="small"
                v-if="scope.row.checkStatus == 1"
                type="success"
                >通过</el-button
              >
              <el-button
                size="small"
                v-else-if="scope.row.checkStatus == 0"
                type="info"
                >待审</el-button
              >
              <el-tooltip
                v-else-if="scope.row.checkStatus == 2"
                class="item"
                effect="dark"
                :content="scope.row.checkDesc"
                placement="bottom"
              >
                <el-button size="small" type="danger">不通过</el-button>
              </el-tooltip>
            </template>
          </el-table-column> -->
          <el-table-column
            fixed="right"
            align="center"
            label="操作"
            width="200"
          >
            <template slot-scope="scope">
              <!-- <el-button v-if="$power('resources-update') || userInfo.userId == scope.row.createBy"
                         @click="onEdit(scope.row)" type="text" size="small">编辑</el-button> -->
              <el-button @click="onPreview(scope.row)" type="text" size="small"
                >查看</el-button
              >
              <el-button @click="onDownLoad(scope.row)" type="text" size="small"
                >下载</el-button
              >
              <el-popconfirm title="确定删除吗？" @confirm="onDel(scope.row)">
                <el-button
                  class="ml-md danger"
                  v-if="
                    $power('moralHeart-delete') ||
                    userInfo.userId == scope.row.createBy
                  "
                  slot="reference"
                  type="text"
                  size="small"
                  >删除</el-button
                >
              </el-popconfirm>
            </template>
          </el-table-column>
          <pagination
            class="mb-md mr-md"
            slot="append"
            :pageObj="filterForm"
            @handleSizeChange="handleSizeChange"
            @handleCurrentChange="handleCurrentChange"
          ></pagination>
        </el-table>
      </div>

      <el-dialog title="资源上传" :visible.sync="dialogNewResources">
        <el-form
          v-loading="saving"
          class="content-box"
          ref="elNewresourcesForm"
          :model="newresourcesForm"
          :rules="rules"
        >
          <el-form-item label="资源分类" prop="catalogCode">
            <el-cascader
              size="small"
              v-model="newresourcesForm.catalogCode"
              :options="catalogList"
              :props="{
                value: 'catalogCode',
                label: 'catalogName',
                children: 'catalogList',
                emitPath: false
              }"
            ></el-cascader>
          </el-form-item>
          <el-form-item prop="infoName" label="资源名称">
            <el-input
              size="small"
              v-model="newresourcesForm.infoName"
              placeholder="资源名称"
            ></el-input>
          </el-form-item>
          <el-form-item prop="disciplineCode" label="学科">
            <disciplineSelector
              v-model="disciplineForEdit"
            ></disciplineSelector>
          </el-form-item>
          <el-form-item label="年级" prop="grade">
            <gradeSelector v-model="gradeForEdit"></gradeSelector>
          </el-form-item>
          <el-form-item label="文件上传">
            <fileAgent v-model="fileList" :multiple="false"></fileAgent>
            <!-- <Uploader :limit="1" accept="*.*" :multiple="false" :file-list.sync="fileList"></Uploader> -->
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer text-center">
          <el-button @click="dialogNewResources = false">取 消</el-button>
          <el-button type="primary" @click="onSave" :loading="saving"
            >确 定</el-button
          >
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { fileSizeFilter, getFileType, lookFile } from '@/utils/index.js'
import FileSaver from 'file-saver'
import { mapGetters, mapState } from 'vuex'
import Pagination from '../../components/Pagination.vue'
import DicSelector from '../../components/school/dicSelector.vue'
import disciplineSelector from '../../components/school/disciplineSelector.vue'
import fileAgent from '../../components/school/fileAgent.vue'
import fileTypeSelector from '../../components/school/fileTypeSelector.vue'
import gradeSelector from '../../components/school/gradeSelector.vue'
import { getData, postJson } from '../../http/fetch.js'
import schoolTermSelector from '@/components/school/schoolTermSelector.vue'
import schoolYearSelector from '@/components/school/schoolYearSelector.vue'
const resourcesForm = {
  attachName: '',
  classify: '',
  attachSize: 0,
  attachType: '',
  attachUrl: '',
  catalogCode: '',
  createBy: '',
  createTime: '',
  disciplineCode: '',
  disciplineName: '',
  grade: 0,
  gradeName: '',
  id: 0,
  infoCode: '',
  infoName: '',
  isDeleted: 0,
  operatorId: '',
  orgCode: '',
  schoolCode: '',
  unit: 0,
  unitName: '',
  updateBy: '',
  updateTime: ''
}
export default {
  components: {
    disciplineSelector,
    DicSelector,
    gradeSelector,
    Pagination,
    fileAgent,
    fileTypeSelector,
    schoolTermSelector,
    schoolYearSelector
  },
  name: 'resources',
  data() {
    return {
      loading: false,
      saving: false,
      tableData: [],
      catalogList: [],
      currentCatalogCode: '',
      newresourcesForm: resourcesForm,
      dialogNewResources: false,
      filterForm: {
        schoolYear: null,
        schoolTerm: null,
        isMine: false,
        sortBy: '0',
        disciplineTemp: null,
        gradeTemp: null,
        classify: '',
        catalogCode: '',
        disciplineCode: '',
        grade: 0,
        keyword: '',
        orgCode: '',
        pageNum: 1,
        pageSize: 10,
        total: 0,
        queryEndTime: '',
        queryStartTime: '',
        unit: null
      },
      rules: {
        catalogCode: [
          { required: true, message: '请选择资源分类', trigger: 'change' }
        ],
        infoName: [
          { required: true, message: '请输入资源名称', trigger: 'change' }
        ],
        attachUrl: [
          { required: true, message: '请上传资源', trigger: 'change' }
        ]
      }
    }
  },
  computed: {
    ...mapState(['userInfo', 'currentSemester']),
    ...mapGetters(['schoolCode', 'operatorId', 'schoolCodes']),
    disciplineForEdit: {
      get() {
        return {
          disciplineCode: this.newresourcesForm.disciplineCode,
          disciplineName: this.newresourcesForm.disciplineName
        }
      },
      set(v) {
        if (v) {
          this.newresourcesForm.disciplineCode = v.disciplineCode
          this.newresourcesForm.disciplineName = v.disciplineName
        } else {
          this.newresourcesForm.disciplineCode = null
          this.newresourcesForm.disciplineName = null
        }
      }
    },
    gradeForEdit: {
      get() {
        return {
          grade: this.newresourcesForm.grade,
          gradeName: this.newresourcesForm.gradeName
        }
      },
      set(v) {
        if (v) {
          this.newresourcesForm.grade = v.grade
          this.newresourcesForm.gradeName = v.gradeName
        } else {
          this.newresourcesForm.grade = null
          this.newresourcesForm.gradeName = null
        }
      }
    },
    fileList: {
      get() {
        if (this.newresourcesForm.attachUrl) {
          return [
            {
              attachName: this.newresourcesForm.attachName,
              attachSize: this.newresourcesForm.attachSize,
              attachType: this.newresourcesForm.attachType,
              attachUrl: this.newresourcesForm.attachUrl
            }
          ]
        } else {
          return []
        }
      },
      set(v) {
        if (v && v.length > 0) {
          this.newresourcesForm.attachName = v[0].attachName
          this.newresourcesForm.attachSize = v[0].attachSize
          this.newresourcesForm.attachType = v[0].attachType
          this.newresourcesForm.attachUrl = v[0].attachUrl
          this.newresourcesForm.classify = v[0].classify
        } else {
          this.newresourcesForm.attachName = ''
          this.newresourcesForm.attachSize = 0
          this.newresourcesForm.attachType = ''
          this.newresourcesForm.attachUrl = ''
          this.newresourcesForm.classify = ''
        }
      }
    }
  },
  mounted() {
    this.getData()
  },
  created() {
    this.filterForm.schoolYear = this.currentSemester.schoolYear
    this.filterForm.schoolTerm = this.currentSemester.schoolTerm
    this.currentCatalogCode = this.$route.query.catalogCode
    this.filterForm.catalogCode = this.$route.query.catalogCode
    this.getCatalogInfo()
  },
  watch: {
    'filterForm.disciplineTemp': function () {
      this.search()
    },
    'filterForm.gradeTemp': function () {
      this.search()
    },
    'filterForm.catalogCode': function () {
      this.search()
    },
    'filterForm.classify': function () {
      this.search()
    },
    'filterForm.schoolTerm': function () {
      this.search()
    },
    'filterForm.schoolYear': function () {
      this.search()
    },
    'filterForm.isMine': function () {
      this.search()
    }
  },
  methods: {
    formatterSize(row, column, cellValue, index) {
      return fileSizeFilter(cellValue)
    },
    formatType(row, column, cellValue, index) {
      return getFileType('', '', cellValue).name
    },
    getCatalogInfo() {
      this.$axios
        .get('/share/getCatalogInfo', {
          params: {
            orgCode:
              this.userInfo.teacherSchoolList[0].orgCode ||
              this.userInfo.teacherSchoolList[0].schoolCode,
            menuCode: 'moralHeart'
          }
        })
        .then((res) => {
          this.catalogList = res.data
          if (!this.$route.query.catalogCode && this.catalogList.length > 0) {
            this.currentCatalogCode = this.catalogList[0].catalogCode
            if (
              this.catalogList[0].catalogList &&
              this.catalogList[0].length > 0
            ) {
              this.form.catalogCode =
                this.catalogList[0].catalogList[0].catalogCode
            }
          }
        })
    },
    search() {
      this.filterForm.current = 1
      this.getData()
    },
    getDic(dicType) {
      return new Promise((resolve, reject) => {
        getData('/core/dic/getDictionaryList-page', {
          dicType: dicType,
          pageNum: 1,
          pageSize: -1,
          menuCode: 'moralHeart'
        }).then((res) => {
          if (res.length > 0) {
            res = res.map((m) => {
              return {
                dicCode: m.dicCode,
                dicName: m.dicName
              }
            })
            resolve(res)
          } else {
            reject()
          }
        })
      })
    },
    onPreview(row) {
      lookFile(row.attachUrl)
    },
    onDownLoad(row) {
      FileSaver.saveAs(row.attachUrl, row.attachName)
      postJson('/share/saveDownloadShareInfoLog', {
        infoCode: row.infoCode,
        operatorId: this.operatorId,
        schoolCode: this.schoolCode,
        menuCode: 'moralHeart'
      })
    },
    onDel(row) {
      this.saving = true
      postJson('/share/deleteShareInfo', {
        id: row.id,
        operatorId: this.operatorId,
        menuCode: 'moralHeart'
      })
        .then((res) => {
          this.getData()
          this.$message.success('删除成功！')
        })
        .catch((e) => {})
        .finally(() => {
          this.saving = false
        })
    },
    getData() {
      this.loading = true
      let disciplineCode = this.filterForm.disciplineTemp
        ? this.filterForm.disciplineTemp.disciplineCode
        : ''
      let grade = this.filterForm.gradeTemp
        ? this.filterForm.gradeTemp.grade
        : null
      postJson('/share/getTeacherShareInfoList', {
        schoolCode: this.schoolCode,
        disciplineCode,
        grade,
        userId: this.filterForm.isMine ? this.operatorId : null,
        classify: this.filterForm.classify,
        attachType: this.filterForm.attachType,
        catalogCode: this.filterForm.catalogCode,
        // checkStatus: this.filterForm.isMine ? null : 1, //审核状态：0：待审，1：通过，2：不通过
        keyword: this.filterForm.keyword,
        orgCode:
          this.userInfo.teacherSchoolList[0].orgCode ||
          this.userInfo.teacherSchoolList[0].schoolCode,
        pageNum: this.filterForm.pageNum,
        pageSize: this.filterForm.pageSize,
        queryEndTime: this.filterForm.queryEndTime,
        queryStartTime: this.filterForm.queryStartTime,
        unit: this.filterForm.unit,
        menuCode: 'moralHeart',
        schoolYear: this.filterForm.schoolYear,
        schoolTerm: this.filterForm.schoolTerm
      })
        .then((res) => {
          if (res.records.length > 0) {
            this.tableData = res.records.map((m) => {
              m.fileList = [
                {
                  attachName: m.attachName,
                  attachSize: m.attachSize,
                  attachType: m.attachType,
                  attachUrl: m.attachUrl
                }
              ]
              return m
            })
          } else {
            this.tableData = []
          }
          this.filterForm.size = res.size
          this.filterForm.total = res.total
          this.filterForm.current = res.current
        })
        .catch((e) => {
          this.tableData = []
        })
        .finally(() => {
          this.loading = false
        })
    },
    onCatalogClick(item, n) {
      this.currentCatalogCode = item.catalogCode
      this.filterForm.catalogCode = n.catalogCode
    },
    onNewResources() {
      let row = {
        attachName: '',
        classify: '',
        attachSize: 0,
        attachType: '',
        attachUrl: '',
        catalogCode: '',
        createBy: '',
        createTime: '',
        disciplineCode: '',
        disciplineName: '',
        grade: null,
        gradeName: '',
        id: null,
        infoCode: '',
        infoName: '',
        isDeleted: 0,
        operatorId: '',
        orgCode: '',
        schoolCode: '',
        unit: 0,
        unitName: ''
      }
      this.onEdit(row)
      this.dialogNewResources = true
    },
    onEdit(row) {
      this.newresourcesForm = {
        id: row.id,
        attachName: row.attachName,
        attachSize: row.attachSize,
        attachType: row.attachType,
        attachUrl: row.attachUrl,
        catalogCode: row.catalogCode,
        disciplineCode: row.disciplineCode,
        disciplineName: row.disciplineName,
        grade: row.grade,
        gradeName: row.gradeName,
        infoCode: row.infoCode,
        infoName: row.infoName,
        operatorId: row.operatorId,
        orgCode: row.orgCode,
        schoolCode: row.schoolCode,
        unit: row.unit,
        unitName: row.unitName
      }
      this.dialogNewResources = true
    },
    onSave() {
      this.$refs.elNewresourcesForm.validate((valid) => {
        if (valid) {
          this.saving = true
          postJson('/share/saveOrUpdateShareInfo', {
            ...this.newresourcesForm,
            menuCode: 'moralHeart',
            createName: this.userInfo.userName,
            operatorId: this.operatorId,
            schoolCode: this.schoolCode,
            orgCode:
              this.userInfo.teacherSchoolList[0].orgCode ||
              this.userInfo.teacherSchoolList[0].schoolCode
          })
            .then((res) => {
              this.dialogNewResources = false
              this.$message.success('操作成功！')
              this.filterForm.pageNum = 1
              this.getData()
            })
            .catch((e) => {
              console.error(e)
            })
            .finally(() => {
              this.saving = false
            })
        }
      })
    },
    //分页
    handleSizeChange(pageSize) {
      this.filterForm.pageNum = 1
      this.filterForm.pageSize = pageSize
      this.getData()
    },
    handleCurrentChange(curPage) {
      this.filterForm.pageNum = curPage
      this.getData()
    }
  }
}
</script>

<style lang="less" scoped>
.sec-title {
  font-size: 16px;
  font-weight: 500;
  color: #333333;
  font-family: sr;
}

.el-button.is-disabled.el-button--text {
  color: #c0c4cc !important;
}

.resource-filter {
}

.resource-box {
  position: relative;
  background: #fcfcfc;
  border: 1px solid #dfdfdf;
}

.active-sub {
  color: #2a70ed !important;
}

.sub-catalog {
  cursor: pointer;
  font-size: 14px;
  font-family: pfrgl;
  font-weight: 400;
  color: #666666;
  line-height: 1.5;
  margin-bottom: 6px;

  &:hover {
    color: #2a70ed;
  }
}
</style>
